module.exports = __webpack_public_path__ + "static/media/us_flag.5ee8a14b.svg";